<template>
	<div class="flex flex_col sf-page">
		<!-- 上面的下拉选择 -->
		<div class="flex flex_a_c sf-selects">
			<img class="sf_icon" src="@/assets/image/sf/sf_icon.png" alt="" />
			<el-form class="sf-form warnform-inline" :inline="true" ref="selectForm" :model="selectForm">
				<el-form-item label="选择生产区域" style="margin-bottom: 0" v-if="isShowAllSelect">
					<el-select
						v-model="allOrgId"
						:placeholder="orgAllSelect.length ? '请选择' : '暂无设备'"
						@change="changeAllOrg"
					>
						<el-option
							v-for="(item, index) in orgAllSelect"
							:key="index"
							:value="item.orgId"
							:label="item.orgName"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="isShowAllSelect ? '' : '选择水肥机设备'">
					<el-select v-model="selectForm.deviceId" :placeholder="orgSelect.length ? '请选择' : '暂无设备'">
						<el-option
							v-for="(item, index) in orgSelect"
							:key="index"
							:value="item.id"
							:label="item.deviceName"
						></el-option>
					</el-select>
				</el-form-item>
			</el-form>
		</div>
		<div class="flex flex_col page-content" v-loading="loading">
			<!-- 上面的状态 -->
			<div class="flex flex_ju_sb page-top">
				<div class="sf-left">
					<img class="sf-logo" src="@/assets/image/sf/2.png" alt="" />
				</div>
				<!-- 右边指令状态 -->
				<div class="sf-right" v-if="orgSelect.length">
					<title-model titles="设备指令状态">
						<div class="font_14 c_white cursor btn-refresh" @click="refresh">
							<i class="el-icon el-icon-refresh"></i>
							<span>刷新</span>
						</div>
					</title-model>
					<!-- 下面的指令数据 -->
					<div class="status-wrap">
						<ul class="status-ul">
							<li class="status-li" v-for="(item, index) in infoList" :key="index">
								<div class="flex flex_col flex_ju_c flex_a_c status-div">
									<img class="status-img" :src="setInfoIcons(item)" alt="" />
									<span class="font_16 status-name">{{ item.pidDesc }}</span>
									<div class="bold">
										<span class="font_24" v-if="item.pidDesc.indexOf('状态') > -1">{{
											item.success ? '已开启' : '--'
										}}</span>
										<span class="font_24" v-else>{{ item.v || '--' }}</span>
										<!-- <span class="font_16">℃</span> -->
									</div>
								</div>
							</li>
						</ul>
					</div>
					<!-- <div class="table-empty bottom-empty">
						<img class="table-noimg" src="@/assets/image/sf/empty.png" alt="" />
						<div class="table-emptyword">该网点暂无水肥设备 !</div>
					</div> -->
				</div>
				<div class="table-empty table-empty-big bottom-empty flex flex_col flex_ju_c flex_a_c sf-right" v-else>
					<img class="table-noimg" src="@/assets/image/sf/empty.png" alt="" />
					<div class="table-emptyword">该网点暂无水肥设备!</div>
				</div>
			</div>
			<!-- 下面的执行命令 -->
			<div class="page-bottom" v-if="orgSelect.length">
				<title-model titles="设备可执行指令"></title-model>
				<div class="sf-setwrap">
					<ul class="sf-setul">
						<li class="sf-setli" v-for="(item, index) in cmdList" :key="index" @click="setHandle(item, index)">
							<div class="set-bg-div">
								<img
									class="set-bg"
									:src="
										item.success ? require('@/assets/image/sf/set_bg.png') : require('@/assets/image/sf/set_bgn.png')
									"
									alt=""
								/>
								<img class="icon_icon" :src="setCmdIcons(item)" alt="" />
							</div>

							<div class="set-name">{{ item.pidDesc }}</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import titleModel from '@/components/title-model.vue'
import shuifeiJs from './lib/shuifei'
/**
 * @description 水肥监测
 */

export default {
	components: { titleModel },
	mixins: [shuifeiJs],
	data() {
		return {
			orgAllSelect: [], // 生产区域下拉选
			allOrgId: '', /// 分公司下面选中的orgid
			// 上面的监测站点选择表单
			orgSelect: [], // 上面的下拉选数据
			selectForm: {
				deviceId: '',
			},
			infoData: {}, // 详情总数据
			infoList: [], // 详情列表数据

			cmdList: [], // 可执行指令数据
			loading: true,
		}
	},
	computed: {
		isShowAllSelect() {
			let userOrg = this.getItem('wlwOrg') || {}
			let userOrgs = JSON.parse(userOrg)
			if (userOrgs.orgLevel == 2) {
				return true
			}
			return false
		},
	},
	mounted() {
		if (this.isShowAllSelect) {
			// 获取上面的生产区域信息
			this.getAllOrgids()
		} else {
			this.getOrgids()
		}
	},
}
</script>

<style lang="scss" scoped>
@mixin scrolls() {
	overflow-y: scroll;
	// 背景
	&::-webkit-scrollbar {
		width: 8px;
		height: 8px;
		background-color: transparent;
		border-radius: 4px;
	}
	// 背景
	&::-webkit-scrollbar-track {
		width: 8px;
		height: 8px;
		background-color: transparent;
		border-radius: 4px;
	}
	// 滚动条
	&::-webkit-scrollbar-thumb {
		width: 8px;
		height: 8px;
		border-radius: 4px;
		background-color: #d9d9d9;
	}
}
.sf-page {
	height: 100%;
	min-height: 670px;
	.table-emptyword {
		margin-left: 0;
		margin-top: 0.75rem;
	}
	// 下拉选
	.sf-selects {
		margin-bottom: 0.13rem;
		.sf_icon {
			width: 0.28rem;
			height: 0.44rem;
		}
		.sf-form {
			display: inline-block;
			padding-left: 0;
			margin-left: 0.21rem;
		}
	}

	// 左边
	.sf-left {
		width: 5.88rem;
		height: 4.67rem;
		background: #ffffff;
		border-radius: 0.19rem;
		padding-top: 0.5rem;
		.sf-logo {
			width: 5.46rem;
			margin: auto;
		}
	}
	// 右边
	.sf-right {
		width: 14.09rem;
		height: 4.67rem;
		background: #ffffff;
		border-radius: 0.19rem;
		padding: 0 0 0 0.14rem;
		// 刷新按钮
		.btn-refresh {
			width: 1.06rem;
			height: 0.45rem;
			line-height: 0.45rem;
			background: #42b5b2;
			border-radius: 0.1rem;
			.el-icon {
				font-size: 0.2rem;
				margin-right: 0.11rem;
			}
		}
		// 列表
		.status-wrap {
			margin: 0.17rem 0.06rem 0 0;
			max-height: 3.6rem;
			@include scrolls();
			.status-ul {
				width: 100%;
				text-align: left;
				.status-li {
					display: inline-block;
					margin-left: 0.17rem;
					margin-top: 0;
					color: #2daea9;
					&:nth-child(n + 8) {
						margin-top: 0.2rem;
					}
					&:nth-child(7n + 1) {
						margin-left: 0;
					}
				}
				.status-div {
					width: 1.79rem;
					height: 1.69rem;
					background: #f2f8f9;
					border-radius: 0.13rem;
					font-family: Microsoft YaHei;
				}
				.status-img {
					width: 0.63rem;
					height: 0.63rem;
				}
				.status-name {
					margin: 0.04rem 0 0.19rem;
				}
			}
		}
		.table-empty {
			margin-top: 1rem;
			.table-noimg {
				width: 4.1rem;
				height: 2.27rem;
			}
		}
	}
	.page-content {
		flex: 1;
	}
	// 下面
	.page-bottom {
		flex: 1;
		min-height: 4.67rem;
		background: #ffffff;
		border-radius: 0.19rem;
		margin-top: 0.17rem;
		padding-bottom: 0.21rem;

		// 下面的执行指令列表
		.sf-setwrap {
			margin: 0.26rem 0.31rem 0;

			max-height: 3.6rem;

			@include scrolls();
			// 列表
			.sf-setul {
				width: 100%;
				text-align: left;
			}
			.sf-setli {
				display: inline-block;
				text-align: center;
				cursor: pointer;
				width: 10%;

				&:nth-child(n + 11) {
					margin-top: 0.63rem;
				}
				.set-bg-div {
					margin: auto;
					width: 0.97rem;
					height: 0.97rem;
					position: relative;
				}
				.set-bg {
					width: 0.97rem;
					height: 0.97rem;
				}
				.icon_icon {
					position: absolute;
					width: 0.46rem;
					max-height: 0.46rem;
					top: 50%;
					left: 50%;
					transform: translate(-50%, -50%);
				}
				.set-name {
					font-size: 0.2rem;
					color: #959595;
					margin-top: 0.25rem;
				}
			}
		}
	}
}
</style>
